import { Box } from "@mui/material";
import { ScoreCounter } from "@src/appV2/redesign/EmergencyCredits/components/ScoreCounter";

import { ANIMATION_TIMINGS, NEGATIVE_SCORE_COLOR, SCORE_COLOR } from "../constants";

interface ScoreDisplayProps {
  /**
   * The starting score value
   */
  startScore: number;
  /**
   * The current end score to animate to
   */
  currentEndScore: number;
  /**
   * Whether the counter should be animating
   */
  animationEnabled: boolean;
}

export function ScoreDisplay(props: ScoreDisplayProps) {
  const { startScore, currentEndScore, animationEnabled } = props;

  const color = currentEndScore < 0 ? NEGATIVE_SCORE_COLOR : SCORE_COLOR;

  return (
    <Box sx={{ paddingY: 8 }}>
      <ScoreCounter
        startValue={startScore}
        endValue={currentEndScore}
        animationEnabled={animationEnabled}
        color={color}
        duration={ANIMATION_TIMINGS.SCORE_ANIMATION_DURATION_MS}
      />
    </Box>
  );
}
